import React, { useState, useEffect, useRef } from 'react';
import { HiChevronDown, HiMenu, HiX, HiChevronRight } from "react-icons/hi";
import IVRVue from "../../assets/IVR.png";

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navRef = useRef(null);

  const menuConfig = [
    { label: "About Us", href: "/aboutus-ivr"},
    {
      label: "Products",
      submenu: [
        {
          label: "Chat Bots",
          submenu: [
            { label: "Health Care", href: "/constructionpage" },
            { label: "Meetings & Events", href: "https://meetai.mnrpureai.com" },
            { label: "Travel & Hotels", href: "/constructionpage" },
            { label: "Sales", href: "/constructionpage" },
            { label: "Customer Support", href: "/constructionpage" },
            { label: "Retail Industry", href: "/constructionpage" },
            { label: "Supply chain & logistics", href: "/constructionpage" },
            { label: "Investor community", href: "/constructionpage" },
          ],
        },
        {
          label: "Voice Agents",
          submenu: [
            { label: "Health Care", href: "/constructionpage" },
            { label: "Meetings & Events", href: "https://meetai.mnrpureai.com" },
            { label: "Travel & Hotels", href: "https://ivr-vue.vercel.app" },
            { label: "Call Centers", href: "/constructionpage" },
            { label: "Marketing", href: "/constructionpage" },
            { label: "Retail Industry", href: "/constructionpage" },
            { label: "Supply chain & logistics", href: "/constructionpage" },
            { label: "Investor community", href: "/constructionpage" },
          ],
        },
      ],
    },
    { label: "Data Privacy", href: "/ivr_data_privacy" },
    { label: "Contact Us", href: "/contact" },
  
  ];

  // --- Recursive Component for Mobile Menu ---
  const MobileMenuItem = ({ item, closeMobileMenu }) => {
      const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
      const hasSubmenu = item.submenu && item.submenu.length > 0;

      const handleToggle = (e) => {
          e.preventDefault();
          if (hasSubmenu) {
              setIsSubmenuOpen(prev => !prev);
          }
      };
      
      const handleLinkClick = () => {
          // Only close the main mobile menu if it's a direct link
          if (!hasSubmenu) {
              closeMobileMenu();
          }
      }

      return (
          <li className="text-white/90">
              <a 
                  href={item.href || "#"} 
                  onClick={hasSubmenu ? handleToggle : handleLinkClick}
                  className="flex items-center justify-between w-full py-2"
              >
                  <span>{item.label}</span>
                  {hasSubmenu && (
                      <HiChevronDown className={`w-5 h-5 transform transition-transform duration-300 ${isSubmenuOpen ? 'rotate-180' : ''}`} />
                  )}
              </a>
              {hasSubmenu && isSubmenuOpen && (
                  <ul className="pl-4 mt-1 space-y-1 border-l border-white/20">
                      {item.submenu.map((subItem) => (
                          <MobileMenuItem key={subItem.label} item={subItem} closeMobileMenu={closeMobileMenu} />
                      ))}
                  </ul>
              )}
          </li>
      );
  };

  // Close mobile menu on clicks outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setIsMobileMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="bg-[#0c1e5b] shadow-lg sticky top-0 z-50" ref={navRef}>
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="/ivrvue" aria-label="Go to Homepage">
                <img 
                    src={IVRVue} 
                    alt="IVRVue Logo" 
                    className="h-12 w-auto" 
                />
            </a>
          </div>

          {/* Desktop Navigation */}
          <ul className="hidden md:flex items-center space-x-8 text-white font-medium">
            {menuConfig.map((item) => (
              <li key={item.label} className={item.submenu ? 'relative group' : ''}>
                <a href={item.href || '#'} className="flex items-center p-2 rounded-md hover:bg-white/10 transition-colors">
                  <span>{item.label}</span>
                  {item.submenu && <HiChevronDown className="w-4 h-4 ml-1" />}
                </a>
                {/* First Level Dropdown */}
                {item.submenu && (
                  <ul className="absolute left-0 mt-2 w-56 bg-white text-slate-800 shadow-xl rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform group-hover:translate-y-0 translate-y-2">
                    {item.submenu.map((subItem) => (
                      <li key={subItem.label} className="relative group/submenu">
                        <a href={subItem.href || '#'} className="flex items-center justify-between px-4 py-3 text-sm hover:bg-slate-100 rounded-lg">
                          <span>{subItem.label}</span>
                          {subItem.submenu && <HiChevronRight className="w-4 h-4" />}
                        </a>
                        {/* Second Level Dropdown */}
                        {subItem.submenu && (
                          <ul className="absolute left-full top-0 mt-[-8px] ml-1 w-56 bg-white text-slate-800 shadow-xl rounded-lg opacity-0 invisible group-hover/submenu:opacity-100 group-hover/submenu:visible transition-all duration-300 transform group-hover/submenu:translate-x-0 translate-x-2">
                            {subItem.submenu.map((nestedItem) => (
                              <li key={nestedItem.label}>
                                <a href={nestedItem.href} className="block px-4 py-3 text-sm hover:bg-slate-100 rounded-lg">
                                  {nestedItem.label}
                                </a>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>

          {/* Sign In & Hamburger */}
          <div className="flex items-center">
             {/* <a href="/" className="hidden sm:block bg-yellow-400 text-slate-900 font-semibold rounded-lg px-5 py-2.5 hover:bg-yellow-300 transition-all duration-300 shadow-md">
                Sign In
            </a> */}
            <button
              className="ml-4 md:hidden text-white p-2 rounded-md hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white"
              onClick={toggleMobileMenu}
              aria-label="Toggle mobile menu"
              aria-expanded={isMobileMenuOpen}
            >
              {isMobileMenuOpen ? <HiX className="w-7 h-7" /> : <HiMenu className="w-7 h-7" />}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-indigo-700/95 backdrop-blur-sm px-4 pt-2 pb-4 border-t border-white/20">
            <ul className="space-y-1">
                {menuConfig.map((item) => (
                    <MobileMenuItem key={item.label} item={item} closeMobileMenu={() => setIsMobileMenuOpen(false)} />
                ))}
            </ul>
             {/* <a href="/ivrvue" className="mt-4 block w-full text-center bg-yellow-400 text-slate-900 font-semibold rounded-lg px-5 py-2.5 hover:bg-yellow-300 transition-all duration-300 shadow-md">
                Sign In
            </a> */}
        </div>
      )}
    </header>
  );
};

export default Navbar;
